export default __webpack_public_path__ + "static/media/logo-livros.73d7053b.png";